import styled from 'styled-components'

export const ReviewsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 50px;
  padding: 15px;
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }

`

export const ReviewBar = styled.div`
  width: ${props => props.width}%;

`

export const ReviewsTitle = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: space-between;
  align-items: center;
  margin-top: -40px
  
  h2 {
    font-size: 18px;
    padding-top: 40px;
    font-family: ${props => props.theme.font.family.bold};
    color: black;
  }

  .orange-button {
    font-size: 13px;
    font-family: ${props => props.theme.font.family.medium};

    svg {
      margin-right: 8px;
    }
  }
  @media screen and (min-width: 1100px) {
    h2 {
      font-size: 20px;
    }
    .orange-button {
      font-size: 16px;
    }
  }

`

export const ReviewsContent = styled.div`
  display: grid;
  grid-row-gap: 50px;
  grid-template-rows: auto 1fr;
  @media screen and (min-width: 1100px) {
    grid-template-columns: 6fr 3fr;
    grid-template-rows: auto;
    grid-column-gap: 35px;
    grid-row-gap: 0px;
  }

`

export const ReviewsItems = styled.div`
  display: grid;
  grid-row-gap: 15px;
  grid-template-rows: max-content;
  @media screen and (min-width: 1100px) {
    order: 1;
  }

`

export const ReviewsItem = styled.div`
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding-bottom: 25px;

  p {
    font-size: 14px;
    color: #333e48;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
  }

  h4 {
    font-size: 16px;
    color: black;
    font-family: ${props => props.theme.font.family.bold};
    span {
      font-family: ${props => props.theme.font.family.regular};
      color: #aeaeae;
      font-size: 14px;
    }
  }
  img.review-image {
    margin-bottom: 1rem;
    border: 1px solid grey;
    padding: 5px;
    border-radius: 10px;
    width: 150px;
  }
  @media screen and (min-width: 1100px) {

  }

`

export const ReviewsSummery = styled.div`
  margin-top: -30px;
  h3 {
    font-size: 18px;
    color: #333e48;
    font-weight: normal;
  }

  h4 {
    font-size: 30px;
    color: #333e48;
    display: flex;
    flex-direction: column;
    font-family: ${props => props.theme.font.family.bold};
    margin: 35px 0px 20px 0px;
    span {
      font-size: 14px;
      margin-top: -5px;
      font-family: ${props => props.theme.font.family.regular};
    }
  }
  @media screen and (min-width: 1100px) {
    order: 2;
  }
`

export const ReviewsSummeryStars = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-row-gap: 5px;
  @media screen and (min-width: 1100px) {

  }
`

export const ReviewsSummeryStar = styled.div`
  display: grid;
  grid-template-columns: 2fr 7fr auto;
  align-items: center;

  .rating-bar {
    width: 100%;
    height: 10px;
    border-radius: 4px;
    background-color: #f3f3f3;
    &::before {
      content: '';
      height: 100%;
      display: block;
      border-radius: inherit;
      background-color: #d8d8d8;
      width: ${props => props.width || '0'}%;
    }
  }

  span {
    margin-left: 10px;
  }
  @media screen and (min-width: 1100px) {

  }

`
